module.exports = __webpack_public_path__ + "img/error-bottom.cb297ee4.svg";